/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.main-menu' ).slideToggle();
      } );
      $( '.main-menu__btn' ).on( 'toggleAfter', ( event ) => {
        if ( window.matchMedia( '(max-width: 1279px)' ).matches ) {
          $( event.target ).next() .slideToggle();
        }
      } );

      $( '.main-menu__child-btn' ).on( 'toggleAfter', ( event ) => {
        $( event.target ).next().slideToggle();
      } );

      $( '#main-menu' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget !== null ) {
          const reltarget = $( event.relatedTarget );
          const currenttarget = $( event.currentTarget );
          if ( !reltarget.closest( '#main-menu' ).is( currenttarget ) ) {
            forceToggle();
          }
        }
      } );

      // get all active easytoggle triggers and force a click to close them
      const forceToggle = () => {
        // check active state for all easytoggle elements
        $( '#main-menu' ).find( 'button.is-open' ).each( function() {
          $( this ).trigger( 'click' );
        } );

        $( '.navbar-toggle' ).trigger( 'click' );
      };


      $( '.nav-search__btn-close' ).on( 'click', ( event ) => {
        $( '.nav-search__button' ).trigger( 'click' );
      } );

      // Custom change language form for wpml
      $( '#ll-wpml-select' ).on( 'change', function() {
        const formData = new FormData( $( '#language-form' )[0] );
        const langUrl = formData.get( 'language' );
        window.location = langUrl;
      } );


      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        cursor: 'pop-up-open',
        focus: '.mfp-close',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'body' ).addClass( 'pop-up-open' );
            // get the current instance of the magnificPopup
            const magnificPopup = $.magnificPopup.instance;
            // get the title from data attribute added to button
            const title = magnificPopup.currItem.el.data( 'title' );
            if ( title ) {
              // get the currrent iframe element
              const currIframe = magnificPopup.currTemplate.iframe.find( 'iframe' );

              // add title to the iframe
              currIframe.prop( 'title', title );
            }
            // add a role to the container for accessabilty
            magnificPopup.contentContainer.attr( 'role', 'dialog' );
            magnificPopup.contentContainer.attr( 'aria-label', `${title} player` );

            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      // loop button pause play
      $( document ).on( 'click', '.loop-video-toggle-state', function() {
        if ( $( this ).closest( 'section' ).find( '.loop-video' ).hasClass( 'is-paused' ) ) {
          $( this ).attr( 'title', 'Pause looping video' );
          $( this ).find( '.icon-play' ).hide().attr( 'aria-hidden', 'true' );
          $( this ).find( '.icon-pause' ).show().attr( 'aria-hidden', 'false' );
          $( this ).closest( 'section' ).find( '.loop-video' ).removeClass( 'is-paused' );
          $( this ).closest( 'section' ).find( '.loop-video' ).get( 0 ).play();
        } else {
          $( this ).attr( 'title', 'Play looping video' );
          $( this ).find( '.icon-play' ).show().attr( 'aria-hidden', 'false' );
          $( this ).find( '.icon-pause' ).hide().attr( 'aria-hidden', 'true' );
          $( this ).closest( 'section' ).find( '.loop-video' ).addClass( 'is-paused' );
          $( this ).closest( 'section' ).find( '.loop-video' ).get( 0 ).pause();
        }
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        // $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        // $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger, make smaller to trigger sooner
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
